"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.switchNavigationAction = exports.setProcessAction = exports.selectIsOpen = exports.selectInProcess = exports.resetStateAction = exports.reducer = exports.name = void 0;

var _toolkit = require("@reduxjs/toolkit");

var REDUCER_NAME = 'wrapper/navigate';
var initialState = {
  isOpen: false,
  inProcess: false
};
var slice = (0, _toolkit.createSlice)({
  name: REDUCER_NAME,
  initialState: initialState,
  reducers: {
    resetStateAction: function resetStateAction(state) {
      state['isOpen'] = false;
      state['inProcess'] = false;
    },
    switchNavigationAction: function switchNavigationAction(state, _ref) {
      var payload = _ref.payload;
      state['isOpen'] = payload;
    },
    setProcessAction: function setProcessAction(state, _ref2) {
      var payload = _ref2.payload;
      state['inProcess'] = payload;
    }
  }
});
var _slice$actions = slice['actions'],
    resetStateAction = _slice$actions.resetStateAction,
    setProcessAction = _slice$actions.setProcessAction,
    switchNavigationAction = _slice$actions.switchNavigationAction;
exports.switchNavigationAction = switchNavigationAction;
exports.setProcessAction = setProcessAction;
exports.resetStateAction = resetStateAction;

var selectIsOpen = function selectIsOpen(state) {
  return state[REDUCER_NAME]['isOpen'];
};

exports.selectIsOpen = selectIsOpen;

var selectInProcess = function selectInProcess(state) {
  return state[REDUCER_NAME]['inProcess'];
};

exports.selectInProcess = selectInProcess;
var name = slice['name'];
exports.name = name;
var reducer = slice['reducer'];
exports.reducer = reducer;